(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    (() => {
  const normalize = (value) => (value || '').trim().toLowerCase();

  const updateEngravingField = (picker) => {
    const field = picker.querySelector('[data-custom-engraving-field]');
    const input = picker.querySelector('[data-custom-engraving-input]');
    if (!field || !input) return;

    const engravingOption = Array.from(picker.querySelectorAll('.option-selector')).find((option) => {
      const label = option.querySelector('.label');
      return label && normalize(label.textContent).startsWith('custom engraving');
    });
    if (!engravingOption) return;

    let selected = '';
    const checked = engravingOption.querySelector('input[type="radio"]:checked');
    const select = engravingOption.querySelector('select');
    if (checked) selected = checked.value;
    if (select) selected = select.value;

    const enabled = normalize(selected) === 'yes';
    field.hidden = !enabled;
    input.required = enabled;

    if (!enabled) {
      input.value = '';
    }
  };

  const init = (picker) => {
    updateEngravingField(picker);
    picker.addEventListener('change', () => updateEngravingField(picker));
  };

  document.querySelectorAll('variant-picker').forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('variant-picker').forEach(init);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
